import React from "react";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import { motion } from "framer-motion";
import FuseLoading from "@fuse/core/FuseLoading";
import ReportLocalListItem from "./ReportLocalListItem";
import { useParams } from "react-router-dom/dist";
import Button from "@mui/material/Button";
import history from "@history";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import { ApiUserAdmin, endpoints_auditAdmin } from "app/api/userAdminApi";
import { Box } from "@mui/material";

export default function ReportsLocalList() {
  const [reports, setReports] = React.useState([]);
  const params = useParams();

  const api = new ApiUserAdmin();

  const getReports = async () => {
    try {
      let response;

      response = await api.post(endpoints_auditAdmin.AUDIT_BY_LOCAL, {
        local_id: params.localId,
      });

      setReports(response);
    } catch (error) {
      console.log("🚀 ~ getLocals ~ error:", error);
      return [];
    }
  };

  React.useEffect(() => {
    getReports();
  }, [location]);

  if (!reports) {
    return <FuseLoading />;
  }

  const handleBack = () => history.back();

  return (
    <motion.div
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1, transition: { delay: 0.2 } }}
      className="flex flex-col flex-auto w-full max-h-full"
    >
      <Box mx={{ xs: 2, sm: 4, md: 8 }} width="90%">
        <Button
          style={{ marginBottom: "10px", marginTop: "10px" }}
          variant="contained"
          color="info"
          onClick={handleBack}
          size="small"
          startIcon={
            <FuseSvgIcon size={20}>material-solid:arrow_back</FuseSvgIcon>
          }
        >
          Volver
        </Button>

        {reports.length && reports[0].local ? (
          <h3
            style={{
              textAlign: "center",
              marginBottom: "10px",
              fontWeight: "bold",
            }}
          >
            {reports[0]?.local.fantasy_name}
          </h3>
        ) : null}

        {reports.map((report, key) => (
          <Box key={key} mb={2}>
            <Divider />
            <List sx={{ m: 0, p: 0 }}>
              <ReportLocalListItem key={report.id} report={report} />
            </List>
          </Box>
        ))}
      </Box>
    </motion.div>
  );
}
